import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { Button, Form, FormProps } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import Radio, { RadioGroup } from '../Radio';
import TextInput from '../TextInput';

export type EmailType = 'personal' | 'work';

export type Email = {
  type: EmailType;
  email: string;
};

export type customEmailFormProps = FormProps &
  React.PropsWithoutRef<{
    existingEmail?: Email;
    handleClose: () => void;
    handleOnSubmit: (formData: any) => void;
  }>;

const newAddress: Email = {
  type: 'personal',
  email: '',
};

const EmailForm = ({
  existingEmail = newAddress,
  handleClose,
  handleOnSubmit,
  ...props
}: customEmailFormProps) => {
  const [email] = useState<Email>(existingEmail);

  const isEditForm = email['email'] !== '';

  const validationSchema = yup.object().shape({
    type: yup.string().required('Type is required'),
    email: yup
      .string()
      .email('Email is invalid')
      .required('Email is required')
      .max(245, 'Must be no longer than 245 characters'),
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: email,
    resolver: yupResolver(validationSchema),
  });

  const handleSubmitForm = (formData: any) => {
    handleOnSubmit(formData);
  };

  return (
    <Form {...props}>
      <h4 className="mb-12 text-sm-20-lg-32">
        {isEditForm ? 'Edit Email' : 'Add New Email'}
      </h4>
      {!isEditForm && (
        <>
          <Form.Label className="text-fs-6">Type of Email</Form.Label>
          <Controller
            name={'type'}
            control={control}
            render={({ field }) => (
              <RadioGroup {...field}>
                <Radio
                  value="personal"
                  id="email-type-personal"
                  label="Personal"
                  className="mt-6 text-sm-12-lg-14"
                />
                <Radio
                  value="work"
                  id="email-type-work"
                  label="Work"
                  className="mt-6"
                />
              </RadioGroup>
            )}
          />
        </>
      )}
      <Controller
        name={'email'}
        control={control}
        render={({ field }) => (
          <TextInput
            {...field}
            leftIcon={light('at')}
            label="Email Address"
            className="mt-8"
            placeholder="email address"
            isInvalid={!!errors.email}
          />
        )}
      />
      {errors.email && (
        <div className="error-message">
          <span>{errors.email.message}</span>
        </div>
      )}
      <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
        <Button
          className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
          variant="primary-outline"
          onMouseDown={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="order-1 order-lg-2"
          onClick={handleSubmit(handleSubmitForm)}
        >
          Save
        </Button>
      </section>
    </Form>
  );
};

export default EmailForm;
